import Keyboard, { KeyboardReactInterface } from "react-simple-keyboard";
import React, { ChangeEventHandler, useRef, useState } from "react";
import "./Keyboard.scss";
import Input from "./Input";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SvgIcon from "@mui/material/SvgIcon";

interface KeyboardProps {
  type?: string;
  layoutName?: string;
  onClick: () => void;
  onClose: () => void;
  onKeyPress: any;
  driverNameInput?: string;
  titleDec?: string;
}

const KeyboardWrap: React.FC<KeyboardProps> = ({
  type,
  onClick,
  onKeyPress,
  onClose,
  layoutName,
  driverNameInput,
  titleDec,
}) => {
  const [lngType, setLngType] = useState<string>("영어")
  const [lngLicenseType, setLngLicenseType] = useState<string>("한글")
  const keyboardRef = useRef<KeyboardReactInterface | null>(null);

  const theme =
    type === "text"
      ? "hg-theme-default hg-theme-ios"
      : " hg-theme-default hg-theme-number";
  const textLayout = {
    default: [
      "ㅂ ㅈ ㄷ ㄱ ㅅ ㅛ ㅕ ㅑ ㅐ ㅔ",
      "ㅁ ㄴ ㅇ ㄹ ㅎ ㅗ ㅓ ㅏ ㅣ",
      "{shift} ㅋ ㅌ ㅊ ㅍ ㅠ ㅜ ㅡ {bksp}",
    ],
    shift: [
      "ㅃ ㅉ ㄸ ㄲ ㅆ ㅛ ㅕ ㅑ ㅒ ㅖ",
      "ㅁ ㄴ ㅇ ㄹ ㅎ ㅗ ㅓ ㅏ ㅣ",
      "{shift} ㅋ ㅌ ㅊ ㅍ ㅠ ㅜ ㅡ {bksp}",
    ],
  };

  const textEngLayout = {
    default: [
      "1 2 3 4 5 6 7 8 9 0",
      "q w e r t y u i o p",
      "a s d f g h j k l",
      "{shift} z x c v b n m {bksp}",
    ],
    shift: [
      "1 2 3 4 5 6 7 8 9 0",
      "Q W E R T Y U I O P",
      "A S D F G H J K L",
      "{shift} Z X C V B N M {bksp}",
    ],
  };

  const numberLayout = {
    default: ["1 2 3", "4 5 6", "7 8 9", "지우기 0 재입력"],
    shift: ["1 2 3", "4 5 6", "7 8 9", "지우기 0 재입력"]
  };
  const display = {
    "{alt}": ".?123",
    "{smileys}": "\uD83D\uDE03",
    "{shift}": "⇧",
    "{enter}": "return",
    "{bksp}": "⌫",
    "{altright}": ".?123",
    "{downkeyboard}": "🞃",
    "{space}": " ",
    "{default}": "ABC",
    "{back}": "⇦",
  };

  const lngChange = () => {

    if (lngType === "한글") setLngType("영어")
    else setLngType("한글")

  }

  const lincenseLngChange = () => {
    if (lngLicenseType === "숫자") setLngLicenseType("한글")
    else setLngLicenseType("숫자")
  }

  //   const onKeyPress = (button: string) => {
  //     console.log(button);
  //   };

  const getLayout = () => {
    if (type) {
      if (type === "text" && lngType === "한글") {
        return textEngLayout
      } else if (type === "text" && lngType === "영어") {
        return textLayout
      } else if (type === "number" && lngLicenseType === "숫자") {
        return textLayout
      } else if (type === "number" && lngLicenseType === "한글") {
        return numberLayout
      }
      return textLayout
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          width: "100%",
          bottom: "7%",
          zIndex: "9999",
          background: "#3c404a",
        }}
      >
        <div className="keyboard-input-wrap">
          <div className="keyboard-title-wrap">
            <span>{titleDec}</span>
            <SvgIcon
              component={CloseOutlinedIcon}
              style={{
                fontSize: "3em",
                position: "absolute",
                left: "90%",
                color: "white",
              }}
              onClick={onClose}
            ></SvgIcon>
          </div>
          <Input
            type={"text"}
            className="input-type1"
            maxLength={11}
            placeholder=""
            onChange={(e) => { }}
            readOnly={true}
            value={driverNameInput ? driverNameInput : ""}
          ></Input>
        </div>
        <Keyboard
          keyboardRef={(r) => (keyboardRef.current = r)}
          layout={getLayout()}
          display={display}
          onKeyPress={onKeyPress}
          theme={theme}
          layoutName={layoutName}
        ></Keyboard>
        <div className="btn-wrap" style={{ display: 'flex' }}>

          {type === "text" && (<div onClick={() => { lngChange() }} style={{ background: '#71757c', borderRadius: '12px', fontWeight: '700', fontSize: '2.4em', whiteSpace: 'nowrap', padding: '10px', textAlign: 'center', justifyContent: 'center', alignItems: 'center', marginRight: '10px', display: 'flex' }}><span>{lngType}</span></div>)}
          {type === "number" && titleDec?.includes("면허번호") && (<div onClick={() => { lincenseLngChange() }} style={{ background: '#71757c', borderRadius: '12px', fontWeight: '700', fontSize: '2.4em', whiteSpace: 'nowrap', padding: '10px', textAlign: 'center', justifyContent: 'center', alignItems: 'center', marginRight: '10px', display: 'flex' }}><span>{lngLicenseType}</span></div>)}
          <button
            style={{
              fontSize: "3em",
              border: "none",
              borderRadius: "0.3em",
              padding: "0.5em",
            }}
            onClick={() => {
              onClick();
            }}
          >
            확인
          </button>
        </div>
      </div >
    </>
  );
};

export default KeyboardWrap;
